module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-36x36.4b3121eb5d80418ee9dd8af5f6bbde0c.png";